import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
// import profilePic from "../../assets/SuvranilG2.jpg";
import profilePic from "../../assets/S-logo.png";




export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={profilePic} alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi! I am {" "}
                <span className="different">Suvranil Ghose,  </span> 
                an aspiring MERN stack developer with a passion for designing and developing scalable, efficient, and user-friendly web applications.{" "}
                <br/>
                <span className="different">My career objective{" "}  </span>
                is to leverage my skills to create innovative solutions that meet the needs of clients and end-users. 
                
                I am committed to staying up to date with the latest technologies and trends in the field of web development to ensure that I can deliver the best possible results.{" "}
                <span className="different">My goal {" "}  </span>                
                is to become a leading Full-stack developer and contribute to the growth and success of the organization I work for.
                
              </h4>
              
              
              <h4>Terms That can describe me apart from Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Sports Enthusiast{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Nature Lover{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Traveller{" "}
              </h4>
              {/* <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Poet{" "}
              </h4> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
